import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { genesysCloudWorkItemIntegrationsReducer } from './reducers/work-item-integrations.reducer';
import { featureKey } from './reducers/feature-key';
import { EffectsModule } from '@ngrx/effects';
import { GenesysCloudWorkItemIntegrationsEffects } from './effects/work-item-integrations.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudWorkItemIntegrationsReducer),
    EffectsModule.forFeature([
      GenesysCloudWorkItemIntegrationsEffects
    ])
  ]
})
export class GenesysCloudWorkItemIntegrationsModule {}
